// removed by extract-text-webpack-plugin
module.exports = {"fields":"_3BW3UTLQ0OZcViaudNtlEe","drop":"_3EIKslvTsYnZ9a2M6tBIAX"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/DragNDrop/Drop/index.css
// module id = 199
// module chunks = 0